// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner__loader__10SBU","load8":"Spinner__load8__29cnZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/UI/Spinner/Spinner.css
// module id = 139
// module chunks = 3